import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  IDullReceipt,
  IDullReceiptInitialState,
} from "./dullReceiptModel";
import {
  createDullReceipt,
  deleteDullReceipt,
  deleteDullReceiptOrderItems,
  findAllDullReceipt,
  findAllPendingDullOrder,
  getDullReceiptById,
  updateDullReceipt,
} from "./services/dullReceipt.services";

const initialState: IDullReceiptInitialState = {
  loading: false,
  error: "",
  DullReceiptID: null,
  DullReceiptOrderItemIndex: -1,
  DullReceiptOrderSelectionDialog: false,
  DullReceiptList: [],
  DullPendingOrderList: [],
  DullReceiptDetail: {
    karigar_id: null,
    receipt_date: new Date(),
    charges: null,
    karigar_name: "",
    gold_rate: null,
    dull_receipt_order: [],
  },
  FilterDullReceipt: {
    karigar_name: "",
    karigar_nick_name: "",
    receipt_date: "",
  },
};

const dullReceiptSlice = createSlice({
  name: "dullreceipt",
  initialState,
  reducers: {
    setDullReceiptID: (state, action) => {
      state.DullReceiptID = action.payload;
    },
    clearDullReceiptDetail: (state) => {
      state.DullReceiptDetail = initialState.DullReceiptDetail;
    },
    setDullReceiptOrderItemIndex: (state, action) => {
      state.DullReceiptOrderItemIndex = action.payload;
    },
    setFilterDullReceipt: (state, action) => {
      state.FilterDullReceipt = action.payload;
    },
    clearFilterDullReceipt: (state) => {
      state.FilterDullReceipt = initialState.FilterDullReceipt;
    },
    openDullReceiptOrderSelectionDialog: (state) => {
      state.DullReceiptOrderSelectionDialog = true;
    },
    closeDullReceiptOrderSelectionDialog: (state) => {
      state.DullReceiptOrderSelectionDialog = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(findAllDullReceipt.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      findAllDullReceipt.fulfilled,
      (state, action: PayloadAction<IDullReceipt[]>) => {
        state.loading = false;
        state.DullReceiptList = action.payload || [];
      }
    );
    builder.addCase(findAllDullReceipt.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.DullReceiptList = [];
    });

    builder.addCase(createDullReceipt.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createDullReceipt.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createDullReceipt.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(updateDullReceipt.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateDullReceipt.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateDullReceipt.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteDullReceipt.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteDullReceipt.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteDullReceipt.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getDullReceiptById.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getDullReceiptById.fulfilled, (state, action: any) => {
      state.loading = false;
      state.DullReceiptDetail = action.payload;
    });
    builder.addCase(getDullReceiptById.rejected, (state, action) => {
      state.loading = false;
      state.DullReceiptDetail = initialState.DullReceiptDetail;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteDullReceiptOrderItems.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteDullReceiptOrderItems.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteDullReceiptOrderItems.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(findAllPendingDullOrder.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      findAllPendingDullOrder.fulfilled,
      (state, action: PayloadAction<any[]>) => {
        state.loading = false;
        state.DullPendingOrderList = action.payload || [];
      }
    );
    builder.addCase(findAllPendingDullOrder.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.DullPendingOrderList = [];
    });
  },
});

export const {
  clearDullReceiptDetail,
  setDullReceiptID,
  setDullReceiptOrderItemIndex,
  clearFilterDullReceipt,
  setFilterDullReceipt,
  closeDullReceiptOrderSelectionDialog,
  openDullReceiptOrderSelectionDialog,
} = dullReceiptSlice.actions;
export default dullReceiptSlice.reducer;
